module.exports = __webpack_public_path__ + "static/week_week5_spot6-0caa09bad719400f60637ff21c354623.jpg";